//测试支付接口host https://dev2payment.happyelements.com
//线上支付接口host https://webpay2.happyelements.cn
function formatParams(method, data) {
    if (!data) {
        return null
    } else if (typeof data === "string") {
        return data
    }
    // if (method === "POST") {
    //     return JSON.stringify(data)
    // }
    var arr = [];
    for (var name in data) {
        var value = data[name]
        // 手工过滤 #
        if (!value && value !== "#") {
            continue
        }
        arr.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
    }
    return arr.join("&");
}

function makeRequest(method, url, params) {
    var dealedParams = formatParams(method, params);
    if (method == "GET" && dealedParams) {
        url = url + "?" + dealedParams;
        dealedParams = null;
    }
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, url);
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        if (method === "POST") {
            xhr.setRequestHeader("Content-Type", "application/json");
        }
        xhr.send(dealedParams);
    });
}

var payment = {

    channelId: 133,

    gspappid: 8800109151,

    recharge: function (uid, score, successCallback, failCallback, closeCallback) {
        window.__paySuccess = function (data) {
            //支付成功执行
            successCallback(data);
        }

        window.__payError = function (data) {
            //支付失败执行
            if(!data) data = {};
            data.type = 1;
            failCallback(data);
        }

        window.__payClose = function (data) {
            //关闭对话框执行,IOS下无效
            closeCallback(data);
        }
        console.log("[######]call wanba pay score " + score)
        // 玩吧的支付错误 很难模拟
        window.popPayTips({
            version: 'v2',
            defaultScore: score,
            appid: window.OPEN_DATA.appid
        });
    },

    buy: function (data, successCallback, failCallback, closeCallback) {
        console.log("[#####]call wanba buy")
        let uid = data.uid
        let productId = data.productId
        let itemId = data.itemId
        let score = data.score
        let ext = data.ext

        var that = this;
        this.init(uid, productId, score, ext).then(function (data) {
            console.log(`[####]init buy success`)
            try {
                data = JSON.parse(data);
                cc.log("[####]jsonparsedata ", data)
                if (data.result != 'success')
                    throw "fail to init";
            } catch (error) {
                //初始化订单出错
                data = {
                    code: -1,
                    data: "初始化订单失败"
                }
                failCallback(data);
                return;
            }

            var orderId = data.order_id;
            var params = {};
            params.openid = window.OPEN_DATA.openid;
            params.openkey = window.OPEN_DATA.openkey;
            params.zoneid = window.OPEN_DATA.platform;
            params.orderid = orderId;
            params.itemid = itemId;
            params.product_id = productId;
            //params.pf = XcloverPlatform.qq;

            params.pf = window.OPEN_DATA.pf

            var payUrl = `${PY_HOST}/userpayment/v2/wanba_ts/${that.channelId}/1/pay/${that.gspappid}/${uid}`;

            function cancel() {
                that.cancel(uid, orderId, closeCallback);
            }

            function success() {
                makeRequest("POST", payUrl, params).then(function (data) {
                    console.log(`[####]buy success`)
                    try {
                        data = JSON.parse(data);
                        if (data.extractResult != 0)
                            throw "fail to buy";
                    } catch (error) {
                        data = {
                            code: -3,
                            data: "购买失败"
                        }
                        failCallback(data);
                        return;
                    }
                    data.orderId = orderId;
                    successCallback(data);
                    return;
                }, function (data) {
                    console.log(`[####]buy failed`)
                    if (!data) {
                        data = {
                            code: -3,
                            data: "购买失败"
                        }
                    }
                    failCallback(data);
                    return;
                })
            }

            function fail(data) {
                if (!data) {
                    data = {
                        code: -2,
                        data: "支付失败"
                    }
                }
                failCallback(data);
                return;
            }
            // that.recharge(uid, score, success, fail, cancel);
            that.info(uid).then(function (data) {
                console.log(`[######]get buyinfo success`)
                try {
                    data = JSON.parse(data);
                    if (data.result != "success")
                        throw "fail to get info";
                    data = JSON.parse(data.data);
                    if (!data.score)
                        throw "fail to get info";
                    var currentScore = parseInt(data.score);
                } catch (error) {
                    data = {
                        code: -3,
                        data: "购买失败"
                    }
                    failCallback(data);
                    return;
                }
                
                if(currentScore >= score) {
                    success();
                } else {
                    var chargeScore = score - currentScore;
                    that.recharge(uid, score, success, fail, cancel);
                }
            }, function (data) {
                console.log(`[######]get buyinfo failed`)
                data = {
                    code: -4,
                    data: "查询失败"
                }
                failCallback(data);
                return;
            })
        }, function (data) {
            console.log(`[####]init buy failed`)
            if (!data) {
                data = {
                    code: -1,
                    data: "初始化订单失败"
                }
            }
            failCallback(data);
            return;
        })
    },

    init: function (uid, productId, score, ext) {
        var url = `${PY_HOST}/userpayment/v2/wanba_ts/${this.channelId}/1/init/${this.gspappid}/${uid}`;
        var params = {};
        params.random = new Date().getTime();
        params.product_id = productId;
        params.price = score/10;
        params.currency = 'CNY';
        params.client = 'web';
        params.client_version = '1.0';
        params.client_detail = 'xclover';
        params.locale = 'CN';
        params.language = 'zh';
        params.platform = 'wanba_ts';
        //if (window.OPEN_DATA.qua.app == 'WX')
        //{
        //    params.platform = 'weixin'
        //}
        params.server_id = 1;
        params.zone_id = window.OPEN_DATA.platform;
        params.dcsession_id = 1;
        params.level = 1;
        params.udid = 1;
        params.extend = JSON.stringify(ext) || "";
        return makeRequest("POST", url, params);
    },

    cancel: function (uid, orderId, callback) {
        var url = `${PY_HOST}/userpayment/v2/wanba_ts/${this.channelId}/1/cancel/${this.gspappid}/${uid}`;
        var params = { order_id: orderId };
        makeRequest("GET", url, params).then(function () {
            callback();
            return;
        }, function () {
            callback();
            return;
        });
    },

    info: function (uid) {
        var url = `${PY_HOST}/userpayment/v2/wanba_ts/${this.channelId}/1/getinfo/${this.gspappid}/${uid}`;
        var params = {};
        params.openid = window.OPEN_DATA.openid;
        params.openkey = window.OPEN_DATA.openkey;
        params.zoneid = window.OPEN_DATA.platform;
        //params.pf = XcloverPlatform.qq;

        params.pf = window.OPEN_DATA.pf
        return makeRequest("POST", url, params);
    }
}

module.exports = payment;